const API = {
  POST_CREATE_ARTICLE: {
    path: '/article/expert/create',
    method: 'POST',
  },
  POST_UPDATE_ARTICLE: {
    path: '/article/expert/update',
    method: 'POST',
  },
  GET_ARTICLES_BY_AUTHOR: {
    path: '/article/expert/search',
    method: 'GET',
  },
  GET_ARTICLES_BY_ENT: {
    path: '/article/groups',
    method: 'GET',
  },
  GET_ARTICLES_SUMMARY: {
    path: '/article/expert/details',
    method: 'GET',
  },
  DELETE_ARTICLE: {
    path: '/article/expert/delete',
    method: 'DELETE',
  },
  GET_EXPERTS_LIST: {
    path: '/expert/details/ent',
    method: 'GET',
  },
  GET_CATEGORIES: {
    path: '/categories',
    method: 'GET',
  },
  POST_ASSIGN_CATEGORIES: {
    path: '/categories/assign',
    method: 'POST',
  },
};

export default API;
